import React, { useState } from "react";
import { DeleteModalWrapper, SuccessModalWrapper } from "components/atoms/DeleteModal/DeleteModal.styles";
import Button from "components/molecules/Button";
import delete_img from "assets/delete.png";
import success from "assets/success.gif";
import Toast from "components/molecules/Toast";
import { useAuthContext } from "Context/authContext";

const DeleteModal = ({
  title,
  successTitle = "Deleted SuccessFully",
  btnText = "Yes, Delete",
  img = delete_img,
  onClose,
  onSubmit,
}) => {
  const [successModal, setSuccessModal] = useState(false);
  const [loading, setLoading] = useState(false);
  // const { refetch } = useAuthContext();

  const handleSubmit = (e) => {
    e.preventDefault();
    try {
      setLoading(true)
      onSubmit();
      // setSuccessModal(true);
      // refetch();
      // setLoading(false)
    } catch (error) {
      Toast({
        type: "error",
        message: error?.message,
      });
    }
  };

  return (
    <>
      {!successModal ? (
        <DeleteModalWrapper>
          <div className="image-wrap">
            <img src={img} alt="modal_icon" />
          </div>
          <h2>{title}</h2>
          <Button lg loader={loading} onClick={(e) => {handleSubmit(e)}}>
            {btnText}
          </Button>
        </DeleteModalWrapper>
      ) : (
        <SuccessModalWrapper>
          <div className="image-wrap">
            <img src={success} alt="delete_img" />
          </div>
          <h2>{successTitle}</h2>
        </SuccessModalWrapper>
      )}
    </>
  );
};

export default DeleteModal;
